import React, { useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { LearnMoreLink } from '@bingads-webui-campaign-react/help';
import { ServerEntitySelectorInline } from '@bingads-webui-fluent-component/entity-selector';
import { Text, Label } from '@fluentui/react-components';
import { Info16Regular } from '@fluentui/react-icons';
import { ListSelectorProps, TEXT_CONTENT } from './types/exclusion-lists';
import { CustomWebsiteListTagItemRenderer, useTagContentStyles } from './custom-tag-item-renderer';
import { repository } from './repository';

export const WebsiteListSelector = ({ listType, selected, onChange }: ListSelectorProps) => {
  const i18n: any = useContext(I18nContext);
  const serverContext: any = useContext(ServerContext);
  const classes = useTagContentStyles();

  const fetchData = () => repository.getListsByAccountId(serverContext).then(response => ({
    count: response.SharedEntities?.length || 0,
    items: (response.SharedEntities || []).map(item => ({
      ...item,
      // selection tree requires those props
      value: item.Id,
      content: item.Name,
    })),
  }));

  const renderItemContent = flatItem => (
    <div className={classes.ListItem}>
      <Text aria-label={i18n.getString(_TL_('List name: {{name}}'), { name: flatItem.Name })}>
        {flatItem.Name}
      </Text>
      <Text aria-label={i18n.getString(_TL_('{{itemCount}} websites associated with this list'), { itemCount: flatItem.ItemCount })}>
        {flatItem.ItemCount}{' '}{i18n.getString(_TL_('websites'))}
      </Text>
    </div>
  );

  return (
    <div className={classes.Container}>
      <Text >
        <LearnMoreLink
          isUnderlineLink
          isGreyBackground={false}
          linkType="helpPopup"
          topic="app54866"
          text={i18n.getString(TEXT_CONTENT.description[listType])}
          linkText={i18n.getString(_TL_('Learn more'))}
        />
      </Text>

      <div className={classes.List}>
        <Label
          aria-label={i18n.getString(_TL_('Information about {{listType}} website lists'), { listType })}
          aria-live="polite"
          size="medium"
        >
          {`${i18n.getString(_TL_('Lists'))} (${selected?.length})`}
        </Label>
        <Info16Regular />
      </div>

      <ServerEntitySelectorInline
        i18n={i18n}
        // @ts-ignore
        fetchData={fetchData}
        // @ts-ignore
        value={selected}
        onChange={onChange}
        className={classes.EntitySelector}
        customFilter={(item, search) => item?.Name.toLowerCase().includes(search.toLowerCase())}
        selectionMode="multiselect"
        onRenderTagContent={CustomWebsiteListTagItemRenderer}
        onRenderItemContent={renderItemContent}
        popOverContentBefore={<Text className={classes.PopoverContentBefore}>{i18n.getString(TEXT_CONTENT.listLabel[listType])}</Text>}
        aria-label={i18n.getString(TEXT_CONTENT.ariaLabel[listType])}
      />
    </div>
  );
};

WebsiteListSelector.defaultProps = {
  listType: 'block',
  selected: [],
  onChange: () => { },
};
